import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import router from './router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import VueClipboard from 'vue-clipboard2'
import VueSocketio from 'vue-socket.io'
import VueSweetalert from 'vue-sweetalert2'
import excel from 'vue-excel-export'
import './registerServiceWorker'
import ReadMore from 'vue-read-more'
import { Cropper, PreviewResult } from 'vue-advanced-cropper'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(moment)
Vue.use(momentTimezone)
Vue.use(VueClipboard)
Vue.use(VueSweetalert)
Vue.use(excel)
Vue.use(VueSocketio, process.env.VUE_APP_API_SUB)
Vue.use(ReadMore)

/* eslint-disable no-new */
new Vue({
  store,
  router,
  components: {
    Cropper,
    PreviewResult
  },
  render: h => h(App)
}).$mount('#app')
